// const cookie = require('cookie')

const TOKEN = 'token'
const GROUP = 'group'

let loginMessage = null

export function getAuthToken () {
  return localStorage.getItem(TOKEN)
}

export function isAuthorized () {
  const token = getAuthToken()
  const isAuthorized = token !== null && token.length > 0
  console.log(`isAuthorized: ${isAuthorized}`)
  return isAuthorized
}

export function isAdmin () {
  const group = localStorage.getItem(GROUP)
  return group === 'admin' || group === 'root'
}

export function setAuthToken (token, group) {
  localStorage.setItem(TOKEN, token)
  localStorage.setItem(GROUP, group)
}

export function clearToken () {
  localStorage.removeItem(TOKEN)
  localStorage.removeItem(GROUP)
}

export function sessionEnded (component, message) {
  clearToken()
  loginMessage = message
  component.$router.replace(
    '/login?ret=' + component.$router.currentRoute.path)
}

export function sessionLogout (component) {
  sessionEnded(component, 'ログアウトしました。')
}

export function getLoginMessage () {
  if (loginMessage == null) {
    return null
  }
  return loginMessage
}

export function sessionTimeouted (component) {
  sessionEnded(component, 'セッションが無効になりました。もう一度ログインしてください。')
}

export function distanceText (distance) {
  if (distance >= 10000) {
    return `${(distance / 1000).toFixed(0)} km`
  } else if (distance >= 1000) {
    return `${(distance / 1000).toFixed(1)} km`
  }
  return `${distance} m`
}



// WEBPACK FOOTER //
// ./src/lib/common.js